import { FC } from 'react'

import { Provider } from 'jotai'
import {
  IconStackedBarChart,
  GreyGrey70,
  Inspector
} from '@sequencehq/core-components'

import { useLogEvent } from 'lib/postHog/useLogEvent'
import { InspectorContent } from './InspectorContent'

export const QuoteAnalyticsInspectorItem: FC = () => {
  const { logEvent } = useLogEvent()

  return (
    <Inspector.IconItem
      data-testid="quote-inspector-analytics"
      tooltip="Analytics"
      content={
        <Provider>
          <InspectorContent />
        </Provider>
      }
      icon={<IconStackedBarChart color={GreyGrey70} />}
      onClick={isOpening => {
        if (isOpening) {
          logEvent({ eventName: 'quote_analytics_inspector_opened' })
        }
      }}
    />
  )
}
